import React, { useMemo } from "react";

import InitialDataListPage from "../components/InitialDataListPage";

const TeamMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
}) => {
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "5%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "Team_Name",
        header: "ชื่อทีม",
        width: "25%",
        align: "start",
        render: (item) => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {item.Team_Color && (
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "4px",
                  backgroundColor: item.Team_Color,
                  border: "1px solid #ddd",
                }}
              />
            )}
            <span>{item.Team_Name || "-"}</span>
          </div>
        ),
      },
      {
        key: "Vehicle_No",
        header: "ทะเบียนรถ",
        width: "15%",
        align: "center",
        render: (item) => item.Vehicle_No || "-",
      },
      {
        key: "Team_Phone1",
        header: "เบอร์โทร",
        width: "15%",
        align: "center",
        render: (item) => {
          const formatPhone = (phone) => {
            if (!phone) return "";
            const digits = String(phone).replace(/\D/g, "").slice(0, 10);
            if (digits.length <= 3) return digits;
            if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
            return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
          };
          const phones = [
            formatPhone(item.Team_Phone1),
            formatPhone(item.Team_Phone2),
            formatPhone(item.Team_Phone3),
          ]
            .filter(Boolean)
            .join(", ");
          return phones || "-";
        },
      },
      {
        key: "Team_Members_Count",
        header: "จำนวนลูกทีม",
        width: "12%",
        align: "center",
        render: (item) => (item.Team_Members?.length || 0) + " คน",
      },
      {
        key: "Team_Status",
        header: "สถานะ",
        width: "10%",
        align: "center",
        render: (item) => (
          <span
            style={{
              padding: "4px 12px",
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: "500",
              backgroundColor:
                item.Team_Status === "A" ? "#d4edda" : "#f8d7da",
              color: item.Team_Status === "A" ? "#155724" : "#721c24",
            }}
          >
            {item.Team_Status === "A" ? "ใช้งาน" : "ไม่ใช้งาน"}
          </span>
        ),
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "9%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#EF6C00",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#EF6C00";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#EF6C00";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.Team_Name,
      item?.Vehicle_No,
      item?.Team_Phone1,
      item?.Team_Phone2,
      item?.Team_Phone3,
      item?.Team_Status === "A" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/team"
      data={masterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      fieldMappings={{ no: "Team_Id" }}
      getRowId={(item) => item?.Team_Id}
    />
  );
};

export default TeamMain;

